module.exports = __webpack_public_path__ + "img/average.e95845db.png";